
import React from 'react';

import { Outlet } from 'react-router-dom';

import Header from '../Components/header/Header';


const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      
      <Header />
      <main className="flex-grow px-6  bg-[#F7F7F7] ">
        <div className='mt-[40px]'>
        <Outlet />
        </div>
       
      </main>
    </div>
  );
};

export default Layout;
